export default {
  every() {
    console.log('every');
    $('[data-stop-propagation]').on('click', function (e) {
      e.stopPropagation();
      e.preventDefault();
    });

    document
      .querySelectorAll('[data-bs-toggle="tooltip"]')
      .forEach(el => new bootstrap.Tooltip(el));

    Plyr.setup('.plyr-video', {
      controls: ['play-large', 'play', 'progress', 'current-time', 'volume', 'fullscreen'],
    });

    app.el.$document
      .on('play', function ({ target }) {
        let currVideo = target.querySelector('video');
        document.querySelectorAll('#main video').forEach(function (video) {
          if (video != currVideo) video.pause();
        });
      })
      .on('ended', function ({ target }) {
        let currVideo = target.querySelector('video');
        currVideo.load();
      });

    $('.footer-banner-grid__swiper .swiper').swiper({
      pagination: false,
      navigation: true,
    });
  },
};
